import { Injectable } from '@angular/core';
import { LiteraryQuote } from '../models/literary-quote.model';
import { LITERARY_QUOTES } from '../data/literary-quotes.data';

@Injectable({ providedIn: 'root' })
export class QuoteService {
  readonly quotes: readonly LiteraryQuote[] = LITERARY_QUOTES;

  /** Random quote for splash screens (changes each call / page load). */
  randomQuote(): LiteraryQuote {
    const list = this.quotes;
    if (!list.length) {
      return { text: 'A room without books is like a body without a soul.', author: 'Marcus Tullius Cicero' };
    }
    const index = Math.floor(Math.random() * list.length);
    return list[index];
  }

  /** Stable quote for the calendar day (same all day for every visitor). */
  dailyQuote(date = new Date()): LiteraryQuote {
    const list = this.quotes;
    if (!list.length) {
      return { text: 'Books are a uniquely portable magic.', author: 'Stephen King' };
    }
    const dayKey = `${date.getFullYear()}-${date.getMonth() + 1}-${date.getDate()}`;
    const index = this.hashString(dayKey) % list.length;
    return list[index];
  }

  private hashString(value: string): number {
    let hash = 0;
    for (let i = 0; i < value.length; i++) {
      hash = (hash * 31 + value.charCodeAt(i)) >>> 0;
    }
    return hash;
  }
}
